// extracted by mini-css-extract-plugin
export default {"cta":"xwWE9P","surpriseDiscountBanner":"v8WfUa"};